import Component from '../../components/Component';
import Timeline from '../../components/Timeline';
import Loading from '../../components/Loading';

import query from './query';
import keys from './keys';
import { withTranslation } from 'react-i18next';

class Summary extends Component {
    constructor() {
        super();
        this.query = query;
    }

    render() {
        const { t } = this.props;
        if (this.state.loading) {
            return <Loading />;
        }

        return (
            <Timeline
                metricType="primary"
                data={this.state.data}
                keys={keys(t)}
                forceRun={this.forceRun}
                content_id={this.props.content_id}
                parent_id={this.props.parent_id}
                hasRightAxis
                rightAxisLabel={t('global.ctr_per')}
                showGoogleFeeds
                hasSecondRightAxis
                rightSecondAxisLabel=""
                hasLeftSecondAxis
                leftSecondAxisLabel={t('global.clicks')}
                leftAxisLabel={t('global.impressions')}
            />
        );
    }
}

export default withTranslation()(Summary);
